<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="handleClose"
    :modal="false"
    width="864px">

    <div class="content">
      <!--left panel-->
      <div class="infoPanel">
        <div class="panel-div">
          <h3 class="panel-title">客户详情：</h3>
          <div class="info">
            <span class="info-span" :title="customerNameField">{{customerNameField}}：</span>
            <span class="info-span" :title="customerName">{{customerName}}</span>
          </div>
          <div class="info">
            <span class="info-span" :title="telephoneOneField">{{telephoneOneField}}：</span>
            <span class="info-span" :title="customerPhone">{{customerPhone}}</span>
          </div>

          <div class="info">
            <label class="info-label">开始时间：</label>
            <span class="info-span">{{startTime}}</span>
          </div>
          <Row style="padding-top: 35px;text-align: center">
            <Col span="11" offset="1" style="float: left;">
              <Card :padding="11" >
                <p slot="title" >{{callTime}}</p>
                <p>通话时长</p>
              </Card>
            </Col>
            <Col span="10" offset="1" style="float: left;">
              <Card :padding="11" >
                <p slot="title" >{{allTime}}</p>
                <p>总时长</p>
              </Card>
            </Col>
          </Row>
        </div>
        <!--待开放-->
        <Divider></Divider>
        <div class="panel-div">
          <div class="info">
            <label class="info-label2">员工工号：</label>
            <span class="info-span">{{agentNum}}</span>
          </div>
          <div class="info">
            <label class="info-label2">员工姓名：</label>
            <span class="info-span">{{employeeName}}</span>
          </div>
           <div class="info">
            <label class="info-label2">员工分机：</label>
            <span class="info-span">{{agentExten}}</span>
          </div>
           <div class="info">
            <label class="info-label2">员工手机：</label>
            <span class="info-span">{{employeeMobile}}</span>
          </div>
        </div>
      </div>
      <!--右侧记录start-->
      <div class="chatPage">
        <div class="taleBox" ref="scroller">
             <div style="margin: 10px 15px 0px 15px;" v-for="(item,index) in AiContent" :key="index">
                  <div v-show="'' != item.agentId" class="ai_staff">
                    <div  class="ai_staff_info">
                      <div  class="ai_staff_infodetail">
                        <p  class="ai_staff_infoname">{{employeeName}}<span>工号{{agentNum}}</span></p>
                        <p  class="ai_staff_infotime">{{item.timestamp}}</p>
                        <div  class="ai_staff_infobk">
                          <img :src="employeeHead" class="ai_staff_infoimg" />
                        </div>
                      </div>
                    </div>
                    <div class="ai_staff_dialotria"  ></div>
                    <div style="clear:both"></div>
                    <p class="ai_staff_dialofont">{{item.content}}</p>
                    <div style="clear:both"></div>
                  </div>
                  <div v-show="'' != item.customerPhone" class="ai_cus">
                    <div  class="ai_cus_info">
                      <div  class="ai_cus_infodetail">
                        <img  src="../../../assets/image/cusHead.png" title="客户头像" class="ai_cus_infoimg"/>
                        <p  class="ai_cus_infoname">&nbsp;&nbsp;&nbsp;<span>{{contentPhone}}</span></p>
                        <p  class="ai_cus_infotime">{{item.timestamp}}</p>
                      </div>
                    </div>
                    <div class="ai_cus_dialotria" ></div>
                    <p class="ai_cus_dialofont" >{{item.content}}</p>
                  </div>
              </div>
        </div>
      </div>
       <!--右侧记录end-->
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "AIprocedurePop",
    props: ['callUuid', 'showAIPop'],
    data(){
      return {
        dialogVisible:false,
        title:'AI助手详情',
        height:500,
        width:620,
        employeeHead: './static/img/customerService.2f81c4b.png',
        customerName:'',
        customerPhone:'',
        agentExten:'',
        employeeMobile:'',
        startTime:'',
        callTime:'',
        agentNum:'',
        allTime:'',
        callState:'',
        employeeName:'',
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        AiContent:[],
        contentPhone:'',
        customerNameField:'',
        telephoneOneField:'',
      }
    },
    methods:{
      initSearch(callUuid) {
        let param = {
          "callUuid":callUuid
        }
        let that = this;
        this.$http.post("callrecords/doAiAssistantRecord.json",param) .then(function (res) {
          let result = res.data;
          if (result.flag != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let allDateList = result.obj;
          if(allDateList){
            if(allDateList.chatList){
              that.customerName = allDateList.customerName;
              that.customerPhone = allDateList.customerPhone;
              that.agentExten = allDateList.agentExten;
              that.employeeMobile = allDateList.employeeMobile;
              that.startTime = allDateList.startTime;
              that.callTime = allDateList.callTime;
              that.allTime = allDateList.allTime;
              that.employeeName = allDateList.employeeName;
              that.agentNum = allDateList.agentNum;
              that.employeeMobile = allDateList.employeeMobile;
              that.contentPhone = allDateList.customerPhone;
              if("1" == that.configInfo.phoneIsHide){
                that.customerPhone = allDateList.customerPhoneHide;
                that.contentPhone = allDateList.customerPhoneHide;
              }
              if("0" == that.configInfo.timeShowStyle){
                that.callTime = allDateList.callTimeSecond;
                that.allTime = allDateList.allTimeSecond;
              }
              that.AiContent = allDateList.chatList;
            }
          }
        });
      },
      getFields: function(){
          let that=this;
          let param={
            moduleId: "1",
            pageNum:0,
            pageSize:0
          };
          this.$http.post("custom/fields.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let fields = res.data.obj.list.content;
            that.customerNameField = fields.find(item => item.customColName == 'customerName').customName;
            that.telephoneOneField = fields.find(item => item.customColName == 'telephoneOne').customName;
          });
        },
      reset() {
        let that = this
      },
      handleClose() {
        this.reset()
        this.$emit('closeAIPop',true)
      },

    },
    computed:{

    },
    watch:{
      showAIPop() {
        this.dialogVisible = this.showAIPop
        if (this.showAIPop) {
          if(this.agentInfo.employeeHead){
            this.employeeHead = this.baseImgURL +this.agentInfo.employeeHead;
          }
          this.getFields();
          this.initSearch(this.callUuid)
        }
      }
    }
  }
</script>

<style scoped lang="css">
.content{
  display: flex;
}
/* 右侧聊天记录start */
.chatPage{
  width: 570px;
  position: relative;
  background: #fff;
  overflow: hidden;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.12), 0 0 6px rgba(0,0,0,0.04);
}
.taleBox {
    height: 500px;
    padding-bottom: 20px;
    /* height: 100%;
    min-height: 100px; */
    overflow-y: auto;
 }
.ai_cus{
    margin:10px 15px 0px 15px;
}
  .ai_cus_info{
      overflow:hidden;
  }
  .ai_cus_infodetail{
      float:left;display: flex;align-items:center;margin-left:5px;
  }
  .ai_cus_infoimg{
      width:48px;margin-right:10px;
  }
  .ai_cus_infoname{
    color:#8e8e8d;margin-right:10px;
  }
  .ai_cus_infotime{
    color:#c1c1c0;
  }
  .ai_cus_dialotria{
    width: 0;height: 0;border-right: 5px solid transparent;border-left: 5px solid transparent;border-bottom: 5px solid #f3f3f3;margin-left:20px;
  }
  .ai_cus_dialofont{
    background-color:#f3f3f3;padding: 10px 20px;border-radius:10px;letter-spacing:2px;display:inline-block; *display:inline; *zoom:1;
  }
.ai_staff{
    margin:10px 15px 0px 15px;
}
  .ai_staff_info{
    overflow:hidden;
    margin-bottom: 10px;
  }
  .ai_staff_infodetail{
    float:right;display: flex;align-items:center;margin-right:5px;
  }
  .ai_staff_infotime{
    color:#c1c1c0;margin-right:10px;
  }
  .ai_staff_infoname{
    color:#8e8e8d;margin-right:10px;
  }
  .ai_staff_infobk{
    width:50px;height:50px;background-color:#65A0FE;border-radius: 50%;position:relative;
  }
  .ai_staff_infoimg{
    border-radius:50%;width:48px;height:48px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-24px;margin-top:-24px
  }

  .ai_staff_dialotria{
    width: 0;height: 0;border-right: 5px solid transparent;border-left: 5px solid transparent;border-bottom: 5px solid #2db7f5;float:right;margin-right:10px;
  }
  .ai_staff_dialofont{
    background-color:#65A0FE;padding: 10px 20px;color:white;border-radius:10px;letter-spacing:2px;float:right;display:inline-block; *display:inline; *zoom:1;
  }


/* 右侧聊天记录end */

  .infoPanel{
    position: relative;
    background: #B3C0D1;
    overflow: hidden;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    width: 250px;
    height: 500px;
    margin-right: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.12), 0 0 6px rgba(0,0,0,0.04);
  }
  .panel-div{
    width: 250px;
    height: calc(100% / 2 + 20px);
  }
  .panel-title{
    margin: 5px;
    width: calc(100% / 2 - 10px);
  }
  .info{
    margin: 5px 10px;
    display: flex;
  }
  .info-label{
    display: inline-block;
    float: left;
  }
.info-label2{
  width:75px;
  display: inline-block;
  float: left;
  font-weight: bold;
}
  .info-span {
    max-width: 150px;
    display:block;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    -o-text-overflow:ellipsis;
    -icab-text-overflow:ellipsis;
    -khtml-text-overflow:ellipsis;
    -moz-text-overflow: ellipsis;
    -webkit-text-overflow:ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/AIprocedurePop.vue